import React from "react";
import { HashLoader } from "react-spinners";
import "./ETL.scss";
import useETL from "./useETL";

const ETL = () => {
  const {
    filteredCorrespondances,
    availableAttributes,
    loading,
    error,
    handleSelectChange,
    handleDescriptionChange,
    handleImporterChange,
  } = useETL();

  // Cette logique de gestion des clics est maintenant supprimée
  // car tous les champs sont toujours visibles et modifiables

  return (
    <div className="etl-container">
      <h2>Documentation des attributs</h2>

      {error && <div className="error-message">{error}</div>}

      {/* Indicateur d'état d'enregistrement */}
      <div className="save-status-indicator">
        {loading ? (
          <div className="save-status-spinner">
            <HashLoader size={18} color={"#ff8a00"} />
          </div>
        ) : (
          <div className="save-status-check">
            <i className="fa fa-check-circle"></i>
          </div>
        )}
      </div>

      <div className="table-container">
        <table className="etl-table">
          <thead>
            <tr>
              <th>Colonne CSV</th>
              <th>Description</th>
              <th>À importer</th>
              <th>Chemin Match</th>
              <th>Titre</th>
            </tr>
          </thead>
          <tbody>
            {filteredCorrespondances.map((item, index) => (
              <tr
                key={index}
                className={item.docPath ? "mapped-row" : "unmapped-row"}
              >
                <td>
                  <div className="column-name">{item.csvColumn}</div>
                  <div className="type-badge">{item.csvType}</div>
                </td>
                <td className="editable-cell">
                  <textarea
                    value={item.csvDescription || ""}
                    onChange={(e) => handleDescriptionChange(e, index)}
                    style={{ width: "100%", minHeight: 80 }}
                  />
                </td>
                <td className="checkbox-cell">
                  <input
                    type="checkbox"
                    checked={item.importer === true}
                    onChange={(e) => handleImporterChange(e, index)}
                  />
                </td>
                <td className="editable-cell">
                  <select
                    value={item.docPath || ""}
                    onChange={(e) => handleSelectChange(e, index)}
                    style={{ width: "100%" }}
                  >
                    <option value="">Sélectionner un attribut</option>
                    {availableAttributes.map((attr, idx) => (
                      <option key={idx} value={attr.path}>
                        {attr.path}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <div className="match-title">{item.docTitle || ""}</div>
                  {item.docType && (
                    <div className="match-type-badge">{item.docType}</div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ETL;
